import React, { useCallback, useState, useEffect } from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import { flightTypesList, getModalType } from '../../common/types';
import { useSearch } from '../../hooks/search';
import { listOfModalTypes } from '../../common/initialItems';
import { IInfoModal } from './types';

const InfoModal = ({ isMobile = false }: IInfoModal) => {
  const {
    infoModal,
    setInfoModal,
    submitSearch,
    setFlightType,
    setOrigins,
    setDestinations,
    setFlightDates,
  } = useSearch();
  const [modalId, setModalId] = useState(listOfModalTypes.generalErrorModal);
  const { t, i18n } = useTranslation(
    infoModal.translationKey || getModalType.GENERAL_ERROR
  );

  useEffect(() => {
    i18n.init();
    setModalId(listOfModalTypes[infoModal.translationKey]);
  }, [i18n, infoModal.translationKey]);

  const onToggle = useCallback(() => {
    setInfoModal((prev) => ({ ...prev, isOpen: !prev.isOpen }));
  }, [setInfoModal]);

  const onPrimaryClick = useCallback(() => {
    if (infoModal.translationKey !== getModalType.GENERAL_ERROR) {
      submitSearch({ ignoreSameDayFlightModal: true });
      if (infoModal.translationKey === getModalType.INVALID_MULTICITY) {
        setFlightType(flightTypesList.ONE_WAY);
        setOrigins((prev) => ({ ...prev, secondLeg: undefined }));
        setDestinations((prev) => ({ ...prev, secondLeg: undefined }));
        setFlightDates((prev) => ({
          ...prev,
          secondFlightDate: undefined,
        }));
      }
      setInfoModal((prev) => ({ ...prev, isOpen: false }));
      return;
    }
    onToggle();
  }, [
    onToggle,
    infoModal,
    setFlightDates,
    setFlightType,
    setOrigins,
    setDestinations,
    setInfoModal,
    submitSearch,
  ]);

  return (
    <SmlsModal
      isOpen={infoModal.isOpen}
      type={isMobile ? 'right' : 'full'}
      className="smls-flight-search-default-modal"
      defaultHeader
      modalColor="light"
      toggle={onToggle}
      idBtnClose={modalId?.closeBtnId}
    >
      <div className="content">
        <h4 id={modalId?.titleId}>{t('title')}</h4>
        <p id={modalId?.descriptionId}>{t('description')}</p>
        <SmlsButton
          id={modalId?.submitBtnId}
          text={t('button')}
          type="button"
          onClick={onPrimaryClick}
        />
      </div>
    </SmlsModal>
  );
};

export default InfoModal;
